export default __webpack_public_path__ + "static/media/02.ff26885b.webp";